'use client'

import { ColorCode, Image, Spacer } from '@vinted/web-ui'
import { Fragment } from 'react'

import { SeparatedList } from '@marketplace-web/common-components/separated-list-ui'
import { colorCodeToHex } from '@marketplace-web/vendor-abstractions/web-util'

import useBumpCheckoutContext from '../../../hooks/useBumpCheckoutContext'

const VISIBLE_THUMBNAILS_LIMIT = 3

const BumpItemThumbnails = () => {
  const { selectedItems } = useBumpCheckoutContext()

  const showHiddenThumbnailsCount = selectedItems.length > VISIBLE_THUMBNAILS_LIMIT

  return (
    <SeparatedList separator={<Spacer orientation={Spacer.Orientation.Vertical} />}>
      {selectedItems.slice(0, VISIBLE_THUMBNAILS_LIMIT).map(item => (
        <Fragment key={item.id}>
          <Image
            src={item.thumbnail}
            styling={Image.Styling.Rounded}
            size={Image.Size.Medium}
            scaling={Image.Scaling.Cover}
          />
        </Fragment>
      ))}
      {showHiddenThumbnailsCount && (
        <Image
          label={`+${selectedItems.length - VISIBLE_THUMBNAILS_LIMIT}`}
          styling={Image.Styling.Rounded}
          size={Image.Size.Medium}
          scaling={Image.Scaling.Cover}
          color={colorCodeToHex(ColorCode.GreyscaleLevel4)}
          testId="hidden-thumbnails-count"
        />
      )}
    </SeparatedList>
  )
}

export default BumpItemThumbnails
